import { render } from "./SocialIcons.vue?vue&type=template&id=3700b78c&scoped=true"
import script from "./SocialIcons.vue?vue&type=script&lang=js"
export * from "./SocialIcons.vue?vue&type=script&lang=js"

import "./SocialIcons.vue?vue&type=style&index=0&id=3700b78c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3700b78c"

export default script